import { ActionFormWithDescription } from "./ActionFormWithDescription";
import { usePaymentReviewMutation } from "./usePaymentReviewMutation";

interface PaymentReviewRejectActionProps {
  transactionId: number;
  isDepositInReview?: boolean;
  isRemainderInReview?: boolean;
  isPaymentInReview?: boolean;
}

export function PaymentReviewRejectAction({
  transactionId,
  isDepositInReview,
  isRemainderInReview,
  isPaymentInReview,
}: PaymentReviewRejectActionProps) {
  const { submitPaymentReview, isLoading } = usePaymentReviewMutation({
    transactionId,
    approved: false,
    isDepositInReview,
    isRemainderInReview,
    isPaymentInReview,
  });

  const canExecute =
    isDepositInReview || isRemainderInReview || isPaymentInReview;

  return (
    <ActionFormWithDescription
      title="Payment Review - Reject"
      buttonText="Reject payment"
      canExecute={canExecute}
      isLoading={!!isLoading}
      onSubmit={submitPaymentReview}
      dataTestId="payment-review-reject"
    />
  );
}
